class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.isCartPopupUpsell = this.dataset.addCartPopup;
    this.isMainProductForm = this.querySelector('form').classList.contains('js-product-form-main');
  }

  init() {
    this.form = this.querySelector('.js-product-form');
    this.submitBtn = this.querySelector('.js-add-to-cart-btn');

    if (this.form && this.submitBtn) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  async handleSubmit(evt) {
    evt.preventDefault();
    if (this.submitBtn.classList.contains('disabled')) return;

    this.submitBtn.setAttribute('aria-disabled', 'true');
    this.submitBtn.classList.add('is-loading');

    try {
      const currentTime = new Date().getTime();
      const formData = new FormData(this.form);
      const [oldCartResponse, blockSettings] = await Promise.all([fetch('/cart.js'), this.getBlockSettings()]);
      const oldCartData = await oldCartResponse.json();

      const items = [];
      const upsellProducts = this.form.querySelectorAll('.upsell-productpage__product');
      const palletProduct = this.form.querySelector('.pallet');
      const addCartPopup = document.querySelector('#add-cart-popup');

      const packsElement = this.form?.querySelector('[data-type="packs"]');
      const m2Element = this.form?.querySelector('[data-type="m2"]');

      const order_unit =
        packsElement && parseFloat(packsElement.dataset.increment) > 1
          ? { value: parseFloat(packsElement.dataset.increment), unit: 'stuks' }
          : m2Element && parseFloat(m2Element.dataset.increment) > 0
          ? { value: parseFloat(m2Element.dataset.increment), unit: 'm2' }
          : null;

      let mainItem = {
        id: formData.get('id'),
        quantity: formData.get('quantity') || 1,
        properties: {
          _block_settings: blockSettings,
          ...(order_unit ? { per: `${order_unit.value} ${order_unit.unit}` } : {}),
        },
      };

      if (upsellProducts.length) {
        const upsellItems = [];
        for (const entry of upsellProducts.entries()) {
          const upsellProduct = entry[1];
          const checkbox = upsellProduct.querySelector('input[type="checkbox"]');
          if (checkbox.checked) {
            const { numberOfProducts, variantId, url } = upsellProduct.dataset;
            const blockSettings = await this.getBlockSettings(url);
            upsellItems.push({
              id: variantId,
              quantity: Number(numberOfProducts),
              properties: {
                // _sid: `sub_${currentTime}`,
                _block_settings: blockSettings,
              },
            });
          }
        }
        items.push(...upsellItems);
        addCartPopup.dataset.upsells = JSON.stringify(upsellItems);
      }

      if (palletProduct) {
        const palletCheck = palletProduct.querySelector('input[type="checkbox"]');
        if (palletCheck?.checked) {
          const blockSettings = await this.getBlockSettings(palletProduct.dataset.url);
          items.push({
            id: palletProduct.dataset.vid,
            quantity: Number(palletProduct.dataset.quantity),
            properties: {
              // _sid: `sub_${currentTime}`,
              _block_settings: blockSettings,
            },
          });
        }
      }

      // if (upsellProducts.length || palletProduct) {
      //   mainItem.properties['_sid'] = `main_${currentTime}`;
      // }
      items.push(mainItem);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.message || 'Error adding to cart');
      }

      const newCartResponse = await fetch('/cart.js');
      const newCartData = await newCartResponse.json();

      this.updateCartItems(newCartData);

      if (!this.isCartPopupUpsell) {
        this.dispatchEvent(
          new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: items[0].id,
            },
          })
        );
      }

      const itemInOldCart = oldCartData.items.find((item) => item.variant_id === items[0].id);
      if (itemInOldCart) {
        this.dispatchEvent(
          new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: items[0].id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: items[0].quantity,
            },
          })
        );
      }

      if (!this.isMainProductForm) {
        const productTitle = data.items?.[0]?.title;
        this.createToast(
          'Toegevoegd aan winkelwagen',
          `${productTitle || 'Product'} is toegevoegd aan uw winkelwagen!`,
          'success'
        );

        this.dispatchEvent(
          new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              no_popup: true,
              cart: newCartData,
              variantId: items[0].id,
            },
          })
        );
      }

      if (this.dataset.type === 'upsell') {
        this.submitBtn.innerHTML = '<span class="icon icon-check" aria-hidden="true"></span>';
        this.submitBtn.classList.add('btn--green');
        this.submitBtn.classList.remove('btn--primary');

        setTimeout(() => {
          this.submitBtn.innerHTML = '<span class="icon icon-cart--add" aria-hidden="true"></span>';
          this.submitBtn.classList.add('btn--primary');
          this.submitBtn.classList.remove('btn--green');
        }, 5000);
      }
    } catch (error) {
      let message = 'Er ging iets fout, probeer het nog eens.';
      if (error.message === 'Parameter Missing or Invalid error') {
        message = 'Maak eerst een keuze!';
      }
      this.createToast('Oeps!', message, 'error');
      this.dispatchEvent(
        new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: error.message },
        })
      );
    } finally {
      this.submitBtn.removeAttribute('aria-disabled');
      this.submitBtn.classList.remove('is-loading');
    }
  }

  async addPalletsToCart(palletProduct, currentTime) {
    const items = [];
    const palletCheck = palletProduct.querySelector('input[type="checkbox"]');

    if (palletCheck?.checked) {
      const blockSettings = await this.getBlockSettings(palletProduct.dataset.url);
      items.push({
        id: palletProduct.dataset.vid,
        quantity: Number(palletProduct.dataset.quantity),
        properties: {
          // _sid: `sub_${currentTime}`,
          _block_settings: blockSettings,
        },
      });

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      const data = await response.json();
      return data;
    }
  }

  async addUpsellsToCart(upsellProducts, currentTime) {
    const addCartPopup = document.querySelector('#add-cart-popup');
    const items = [];

    for (const entry of upsellProducts.entries()) {
      const upsellProduct = entry[1];
      const checkbox = upsellProduct.querySelector('input[type="checkbox"]');

      if (checkbox.checked) {
        const { numberOfProducts, variantId, url } = upsellProduct.dataset;
        const blockSettings = await this.getBlockSettings(url);

        items.push({
          id: variantId,
          quantity: Number(numberOfProducts),
          properties: {
            // _sid: `sub_${currentTime}`,
            _block_settings: blockSettings,
          },
        });
      }
    }

    addCartPopup.dataset.upsells = JSON.stringify(items);

    if (items.length > 0) {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      const data = await response.json();
      return data;
    }
  }

  createToast(title, message, status) {
    console.log(message, status);
    const toast = document.querySelector('.atc-toast');
    const toastTitle = toast.querySelector('.atc-toast__title');
    const toastIcon = toast.querySelector('.atc-toast__icon');
    const toastContent = toast.querySelector('.atc-toast__description');

    switch (status) {
      case 'error':
        toastIcon.classList.add('icon-cancel');
        break;
      case 'success':
        toastIcon.classList.add('icon-check');
        break;
    }

    toastTitle.innerHTML = title;
    toastContent.innerHTML = message;
    toast.classList.add(`atc-toast--${status}`, 'active');

    setTimeout(() => {
      toast.classList.remove('active');
    }, 5000);
  }

  async getBlockSettings(url = this.dataset.url) {
    if (!url) {
      console.log('returning window');
      return window.blockSettings || {};
    }

    const res = await fetch(url);
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const el = doc.querySelector('#product__main [data-block-settings]');
    if (el.dataset.blockSettings !== 'undefined') {
      return JSON.parse(el.dataset.blockSettings);
    }

    return {};
  }

  updateCartItems(newCartData) {
    const cartItemsElements = document.querySelectorAll('[data-cart-items]');

    console.log('Updated cart data:', newCartData);

    cartItemsElements.forEach((element) => {
      element.innerHTML = newCartData.items.length;
    });
  }
}

customElements.define('product-form', ProductForm);

// document.addEventListener('on:cart:add', (e) => {
//     let itemAddedMessage = window.cartStrings.itemAdded.replace('%%title%%', e.detail.cart.items[0].title);
//     showMessage('success', 'fa-check', itemAddedMessage);
// });

// document.addEventListener('on:cart:error', (e) => {
//     showMessage('info', 'fa-times', window.cartStrings.noStock);
// });

document.addEventListener('on:cart:error', (e) => {
  console.log(e);
});

// document.addEventListener('on:cart:add', (e) => {
//     console.log('Product added to cart', e.detail.cart);
// });

// document.addEventListener('on:cart:error', (e) => {
//   console.log('Error adding product to cart', e.detail.error);
// });

// document.addEventListener('on:line-item:change', (e) => {
//     console.log('Line item changed', e.detail);
// });
